import { makeResolveInstance } from '@/shared/helpers/factories/helpers/make-resolve-instance';

export const resolveAdsGramInstance = makeResolveInstance(() => window.Adsgram);
